import { ISPJBPDataResponse } from 'legacy/lut/components/widgets/public/partner360/services/models/ISPJBPDataResponse'
import { getErrorResponse } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

export const fetchEltPlanningData = async <T>(
  uid: string,
  forceUpdate: boolean,
  cancelObject?: HttpCancel
): Promise<ISPJBPDataResponse<T>> => {
  let response

  const url = proxy('/webservice/621/sp/v4/spJBPELTPlanning/call')

  const payload = {
    'p.UID': uid,
    'p.Mode': forceUpdate ? 1 : 0,
  }

  const { app } = appGetState()
  const [accessToken] = getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = `Failed to request ELT Planning Data by UID '${uid}'`
    Logger.log(`${errorMessage}: ${e.message}`)
    response = getErrorResponse<ISPJBPDataResponse<T>>(e.message || errorMessage, {
      Total: -1,
      Data: [],
      Errors: errorMessage,
    })
  }

  return response
}
